import React from "react";
import { connect } from "react-redux";
import "./EditArticleContentList.css";
import { toast } from "react-toastify";
import ArticleEditListItem from "../ArticleEditListItem/ArticleEditListItem";
import { mergeItemRequestAction } from "../../redux/actions/editArticlePanel";

class EditArticleContentList extends React.Component {
  constructor(props) {
    super(props);
    this.updateScrollTop = this.updateScrollTop.bind(this);
    this.setCurDragY = this.setCurDragY.bind(this);
    this.mergeItem = this.mergeItem.bind(this);

    this.scrollTops = [];
    this.curDragY = -1;

    this.panelRefs = {};

    this.state = {
      highlightItemID: null
    };
  }

  componentDidMount() {
    const { lockingID } = this.props;

    if (lockingID != null) {
      if (
        this.panelRefs[lockingID] != null &&
        this.panelRefs[lockingID].current != null
      ) {
        this.panelRefs[lockingID].current.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }

  async mergeItem(fromItemID, concatOnly) {
    const { highlightItemID } = this.state;
    const { mergeItemRequestAction, issue } = this.props;

    if (
      fromItemID != null &&
      highlightItemID != null &&
      fromItemID !== highlightItemID
    ) {
      const issueID = issue.id;

      return await mergeItemRequestAction(
        fromItemID,
        highlightItemID,
        issueID,
        concatOnly,
        toast
      );
    }

    return false;
  }

  updateScrollTop() {
    this.scrollTops = [];
    const { itemIDs } = this.props;

    for (let i = 0; i < itemIDs.length; i++) {
      const itemID = itemIDs[i];
      const topBound = this.panelRefs[itemID].current.offsetTop;
      const height = this.panelRefs[itemID].current.clientHeight;

      const positionData = {
        id: itemID,
        topBound: topBound,
        btmBound: topBound + height
      };

      this.scrollTops.push(positionData);
    }
  }

  setCurDragY(y) {
    this.curDragY = y;
    const highlightItemID = getHighlightItem(this.curDragY, this.scrollTops);

    if (highlightItemID !== this.state.highlightItemID) {
      this.setState({ highlightItemID });
    }
  }

  render() {
    const { itemIDs, getPanelPosition, articleID } = this.props;
    const { highlightItemID } = this.state;

    return (
      <div className="no_move_panel">
        {itemIDs.map((itemID, idx) => {
          this.panelRefs[itemID] = React.createRef();

          return (
            <ArticleEditListItem
              index={idx}
              forwardRef={this.panelRefs[itemID]}
              key={itemID}
              itemID={itemID}
              articleID={articleID}
              mergeItem={this.mergeItem}
              setCurDragY={this.setCurDragY}
              updateScrollTop={this.updateScrollTop}
              getPanelPosition={getPanelPosition}
              shouldHighlight={itemID === highlightItemID}
            />
          );
        })}
      </div>
    );
  }
}

function getHighlightItem(curDragY, scrollTops) {
  const highlightArr = scrollTops.filter(aPositionData => {
    if (aPositionData == null) {
      return false;
    }

    return (
      aPositionData.topBound <= curDragY && curDragY <= aPositionData.btmBound
    );
  });

  let highlightItemID = null;

  if (highlightArr.length > 0) {
    highlightItemID = highlightArr[0].id;
  }

  return highlightItemID;
}

const mapState = state => {
  const { editArticlePanel } = state;
  const { contentEditHistory, lockingID } = editArticlePanel;

  let itemIDs = null;

  if (contentEditHistory.length > 0) {
    itemIDs = contentEditHistory[contentEditHistory.length - 1].itemIDs;
  }

  return {
    itemIDs,
    lockingID
  };
};

const mapDispatch = {
  mergeItemRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(EditArticleContentList);
